import { FC } from "react";
import { WorkCategory } from "../../../../domain/enums/WorkCategoryEnum";
import LogisticsCategoryIconSVG from "../../svg/work-categories/LogisticsCategoryIconSVG";
import BuildingCategoryIconSVG from "../../svg/work-categories/BuildingCategoryIconSVG";
import TransportCategoryIconSVG from "../../svg/work-categories/TransportCategoryIconSVG";
import HomeMasterCategoryIconSVG from "../../svg/work-categories/HomeMasterCategoryIconSVG";

interface WorkCategoryIconsProps {
    category: WorkCategory;
    selected: boolean;
    className: string;
}

const WorkCategoryIcons: FC<WorkCategoryIconsProps> = (props) => {
    if (props.category === WorkCategory.LOGISTICS) {
        return <LogisticsCategoryIconSVG selected={props.selected} className={props.className} />;
    }
    if (props.category === WorkCategory.BUILDING) {
        return <BuildingCategoryIconSVG selected={props.selected} className={props.className} />;
    }
    if (props.category === WorkCategory.TRANSPORT) {
        return <TransportCategoryIconSVG selected={props.selected} className={props.className} />;
    }
    if (props.category === WorkCategory.HOME_MASTER) {
        return <HomeMasterCategoryIconSVG selected={props.selected} className={props.className} />;
    }
    return <></>;
};

export default WorkCategoryIcons;
